import React, { useEffect, useState } from "react";
import {
  Table,
  Select,
  DatePicker,
  Button,
  Typography,
  Space,
  Row,
  Col,
  Menu,
  Dropdown,
  message,
} from "antd";

import {
  DownOutlined,
  ExportOutlined,
  LeftOutlined,
  PrinterOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
import moment from "moment";
import { TraitementService } from "../Services/TraitementService";
import { InterroComptaService } from "../Services/InterroComptaService";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { printFournSoinsComptService } from "../Services/PrintFournSoinsComptService";
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;
const getSelectedYear = () => {
  const currentYear = new Date().getFullYear();
  return currentYear.toString();
};
const FournComptDiv = () => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [exercices, setExercices] = useState([]);
  const [societes, setSocietes] = useState([]);
  const [refetch, setRefetch] = useState(null);
   const [dateDeb, setDateDeb] = useState(null);
    const [dateFin, setDateFin] = useState(null);
  const [selectEcriture, setSelectEcriture] = useState("ALL");
  const [selectedSociete, setSelectedSociete] = useState("all");
  const [pageSize, setPageSize] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalSolde, setTotalSolde] = useState(0);
  const [soldeSelection, setSoldeSelection] = useState(0);
  const traitementFactureService = new TraitementService();
  const interroService = new InterroComptaService();

  useEffect(() => {
    const fetchSocietes = async () => {
      try {
        const societesData = await interroService.getAllFournDivCompt();
        setSocietes(societesData);
      } catch (error) {
        console.error("Erreur lors de la récupération des sociétés :", error);
      }
    };

    const fetchExercices = async () => {
      try {
        const data = await traitementFactureService.getExercices();
        setExercices(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des exercices :", error);
      }
    };
    const fetchDefaultDates = async () => {
      try {
          const paramData = await traitementFactureService.getParamComptable();
                         const yearFromParamData = dayjs(paramData.datedeb).format("YYYY");
                              setSelectedYear(yearFromParamData)
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des dates par défaut :",
          error
        );
      }
    };

    fetchDefaultDates();
    fetchSocietes();
    fetchExercices();
  }, [selectEcriture]);


     useEffect(() => {
        if (selectedYear) {
          setDateDeb(new Date(parseInt(selectedYear), 0, 1));
          setDateFin(new Date(parseInt(selectedYear), 11, 31));
        }
      }, [selectedYear]);
      
  const handleSocieteChange = async (value) => {
    setSelectedSociete(value);
  };
  const handlePreviousSociete = () => {
    const currentIndex = ["all", ...societes.map((s) => s.compte)].findIndex(
      (societe) => societe === selectedSociete
    );
    if (currentIndex > 0) {
      const previousSociete = currentIndex === 1 ? "all" : societes[currentIndex - 2].compte;
      setSelectedSociete(previousSociete);
      handleSocieteChange(previousSociete);
    }
  };
  
  const handleNextSociete = () => {
    const currentIndex = ["all", ...societes.map((s) => s.compte)].findIndex(
      (societe) => societe === selectedSociete
    );
    if (currentIndex < societes.length) {
      const nextSociete = currentIndex === 0 ? societes[0].compte : societes[currentIndex].compte;
      setSelectedSociete(nextSociete);
      handleSocieteChange(nextSociete);
    }
  };

  useEffect(() => {
    if (!selectedSociete) return;
    const fetchListAllParticipant = async () => {
      try {
        const participData = await interroService.getAllListFournisDiversCompt(
          selectedSociete,
          dateDeb,
          dateFin
        );
        setTableData(participData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des participants :",
          error
        );
      }
    };

    fetchListAllParticipant();
  }, [refetch, selectedSociete, dateDeb, dateFin]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
    console.log(value);
    setDateDeb(new Date(value, 0, 1));
    setDateFin(new Date(value, 11, 31));
    setRefetch(Date.now());
    console.log(dateDeb);
  };

  const handlePrint = async () => {
    try {
      printFournSoinsComptService(selectedSociete, selectedYear); // déclenche l'impression

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    }
  };

  const onSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };
 /*  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }; */

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange, // Utilisation de la fonction nommée
  
    selections: [
      {
        key: "select-all",
        text: "Sélectionner toutes les lignes",
        onSelect: () => {
          const allKeys = tableData.map((item) => item.numligne);
          setSelectedRowKeys(allKeys);
          onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
        },
      },
      {
        key: "clear-selection",
        text: "Désélectionner toutes les lignes",
        onSelect: () => {
          setSelectedRowKeys([]);
          onSelectChange([]); // Appel explicite avec un tableau vide
        },
      },
    ],
  
    getCheckboxProps: (record) => ({
      name: record.numligne,
    }),
  };
  const isButtonDisabled = selectedRowKeys.length === 0;

  useEffect(() => {
    const newTotalDebit = tableData.reduce(
      (sum, record) => sum + (record.debit || 0),
      0
    );
    const newTotalCredit = tableData.reduce(
      (sum, record) => sum + (record.credit || 0),
      0
    );
    const newSoldes = newTotalDebit - newTotalCredit;
    setTotalSolde(newSoldes);
    setTotalDebit(newTotalDebit);
    setTotalCredit(newTotalCredit);
  }, [tableData]);

  function formatNumber(number) {
    const num = Number(number);
    if (isNaN(num)) {
      return "0";
    }

    return new Intl.NumberFormat("fr-FR").format(num);
  }

 /*  const handleMenuClick = async (e) => {
    // Extraire les lignes sélectionnées du tableau de données complet
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );
    const totalDebit = selectedRows.reduce(
      (sum, record) => sum + (parseFloat(record.debit) || 0),
      0
    );
    const totalCredit = selectedRows.reduce(
      (sum, record) => sum + (parseFloat(record.credit) || 0),
      0
    );

    // Vérification de si la somme des débits et crédits est égale à zéro
    if (totalDebit !== totalCredit) {
      message.warning("Le solde lettrage n'est pas égal à 0!");
      return;
    }

    try {
      const newLettrage = selectedRows.map((row) => ({
        ...row,
        lettrage: e.key,
      }));

      const response = await interroService.getLettrage(newLettrage);
      message.success("Lettrage effectué avec succès.");
      setRefetch(Date.now()); // Raffraîchir les données si nécessaire
    } catch (error) {
      message.error("Erreur lors du lettrage : " + error.message);
    }
  }; */
  const handleMenuClick = async (e) => {
    // Extraire les lignes sélectionnées du tableau de données complet
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );
    
    // Si l'utilisateur a sélectionné "Lettrer"
    if (e.key === "Oui") {
      const totalDebit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.debit) || 0),
        0
      );
      const totalCredit = selectedRows.reduce(
        (sum, record) => sum + (parseFloat(record.credit) || 0),
        0
      );
  
      // Vérification de si la somme des débits et crédits est égale à zéro
      if (totalDebit !== totalCredit) {
        message.warning("Le solde lettrage n'est pas égal à 0!");
        return;
      }
    }
  
    try {
      const newLettrage = selectedRows.map((row) => ({
        ...row,
        lettrage: e.key,
      }));
  
      const response = await interroService.getLettrage(newLettrage);
      message.success("Lettrage effectué avec succès.");
      setRefetch(Date.now()); // Raffraîchir les données si nécessaire
    } catch (error) {
      message.error("Erreur lors du lettrage : " + error.message);
    }
  };

  const columns = [
    {
      title: "C.J.L",
      dataIndex: "codej",
      key: "codej",
      align: "center",
       sorter: (a, b) => {
        const valueA = a.codej || "";
        const valueB = b.codej || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Date Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      render: (text) => moment(text).format("DD MMM YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datecompta).getTime();
        const valueB = new Date(b.datecompta).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      render: (text) => moment(text).format("MMM YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datetrait).getTime();
        const valueB = new Date(b.datetrait).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.numpiece || "";
        const valueB = b.numpiece || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "N° Fact.",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.numfactipm || "";
        const valueB = b.numfactipm || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.comptegen || "";
        const valueB = b.comptegen || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.comptetiers || "";
        const valueB = b.comptetiers || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => {
        const valueA = a.libelle || "";
        const valueB = b.libelle || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "N° Chéque",
      dataIndex: "numcheque",
      key: "numcheque",
      sorter: (a, b) => {
        const valueA = a.numcheque || "";
        const valueB = b.numcheque || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Lettrage",
      dataIndex: "lettrage",
      key: "lettrage",
      align: "center",
      sorter: (a, b) => {
        const valueA = a.lettrage || "";
        const valueB = b.lettrage || "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Débit
        </div>
      ),
      dataIndex: "debit",
      key: "debit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => parseFloat(a.debit || 0) - parseFloat(b.debit || 0),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Crédit
        </div>
      ),
      dataIndex: "credit",
      key: "credit",
      align: "right",
      fixed:"right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
      sorter: (a, b) => parseFloat(a.credit || 0) - parseFloat(b.credit || 0),
    },
  ];

  const onchangeEcriture = (value) => {
    setSelectEcriture(value);
    setRefetch(Date.now()); // Pour forcer le rechargement des données si nécessaire
  };

  // Fonction pour filtrer les données en fonction du lettrage
  const getFilteredData = () => {
    switch (selectEcriture) {
      case "Non":
        return tableData.filter((data) => data.lettrage);
      case "Oui":
        return tableData.filter((data) => !data.lettrage);
      case "ALL":
      default:
        return tableData;
    }
  };
  const lettrageMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="Oui">Lettrer</Menu.Item>
      <Menu.Item key="Non">Délettrer</Menu.Item>
    </Menu>
  );
  useEffect(() => {
    const selectedRows = tableData.filter((row) =>
      selectedRowKeys.includes(row.numligne)
    );
    const totalDebit = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.debit || 0),
      0
    );
    const totalCredit = selectedRows.reduce(
      (sum, record) => sum + parseFloat(record.credit || 0),
      0
    );

    const newSoldeSelection = totalDebit - totalCredit;
    setSoldeSelection(newSoldeSelection);
  }, [selectedRowKeys, tableData]); // Re-calcul à chaque changement de selectedRowKeys ou tableData

  const exportToExcel = (
    data,
    fileName = `compte ${selectedSociete.compte} ${selectedSociete.fournisseur}.xlsx`
  ) => {
    // Création d'un nouveau classeur
    const workbook = XLSX.utils.book_new();
    // Conversion des données en feuille de travail
    const worksheet = XLSX.utils.json_to_sheet(data);
    // Ajout de la feuille de travail au classeur
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // Exportation du classeur (cela déclenchera le téléchargement)
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <div className="particip-compte-container">
      <Row gutter={16} style={{ marginBottom: "30px" }}>
        <Col>
         {/*  <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <Text>Fournisseurs Divers</Text>
            <Select
              onChange={handleSocieteChange}
              defaultValue={selectedSociete}
              style={{ width: 350 }}
              showSearch
            >
              <Option value="all">Tous les fournisseurs</Option>
              {societes.map((societe) => (
                <Option key={societe.compte} value={societe.compte}>
                  {`${societe.compte} - ${societe.intitule}`}
                </Option>
              ))}
            </Select>
          </Space> */}
          <Space direction="vertical" size="middle" style={{ display: "flex" }}>
  <Text>Fournisseurs Divers</Text>
  <Space>
    <Button
     className="Buttonvalid"
      icon={<LeftOutlined />}
      onClick={handlePreviousSociete}
      disabled={["all", ...societes.map((s) => s.compte)].findIndex(
        (societe) => societe === selectedSociete
      ) === 0}
    />
    <Select
      onChange={handleSocieteChange}
      value={selectedSociete} 
      style={{ width: 350 }}
      showSearch
      filterOption={(input, option) =>
        option.children
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      }
    >
      <Option value="all">Tous les fournisseurs</Option>
      {societes.map((societe) => (
        <Option key={societe.compte} value={societe.compte}>
          {`${societe.compte} - ${societe.intitule}`}
        </Option>
      ))}
    </Select>
    <Button
     className="Buttonvalid"
      icon={<RightOutlined />}
      onClick={handleNextSociete}
      disabled={["all", ...societes.map((s) => s.compte)].findIndex(
        (societe) => societe === selectedSociete
      ) === societes.length}
    />
  </Space>
</Space>
        </Col>
      </Row>
      <Row
        gutter={16}
        justify="space-between"
        align="middle"
        style={{ marginBottom: "16px" }}
      >
        <Col
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "start",
          }}
        >
          <Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Exercice</label>
              <Select
                bordered={false}
                style={{
                  width: 90,
                  marginRight: 10,
                  borderBottom: "1px solid #030303",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {exercices.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Période</label>
              {/*  <RangePicker
                format="DD/MM/YYYY"
                value={[dayjs(dateDeb), dayjs(dateFin)]}
              /> */}
              <RangePicker
                format="DD/MM/YYYY"
                value={[dayjs(dateDeb), dayjs(dateFin)]}
                onChange={(dates) => {
                  if (dates && dates.length === 2) {
                    setDateDeb(dates[0].toDate());
                    setDateFin(dates[1].toDate());
                    setRefetch(Date.now()); // Utiliser setRefetch pour forcer un rechargement des données
                  }
                }}
              />
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label style={{ marginBottom: "30px" }}>Type d'écriture</label>
              <Select
                bordered={false}
                style={{
                  width: 180,
                  marginRight: 10,
                  borderBottom: "1px solid #030303",
                }}
                defaultValue={selectEcriture}
                onChange={onchangeEcriture}
              >
                <Select.Option value="ALL">Toutes les écritures</Select.Option>
                <Option value="Non"> Écritures Non Léttrées</Option>
                <Option value="Oui"> Écritures Léttrées </Option>
              </Select>
            </Space>
          </Space>
        </Col>
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <Space>
            <Button
              onClick={() => exportToExcel(getFilteredData())}
              className="buttonExport"
              icon={<ExportOutlined />}
              disabled={tableData.length === 0} 
            >
              Export Excel
            </Button>

            <Dropdown disabled={isButtonDisabled} overlay={lettrageMenu}>
              <Button>
                Lettrage <DownOutlined />
              </Button>
            </Dropdown>
            <Button
              className="buttonImprim"
              icon={<PrinterOutlined />}
              //onClick={handlePrint}
              disabled={ tableData.length === 0 || totalSolde !==0}
            >
              Imprimer Extrait
            </Button>
          </Space>
        </Col>
      </Row>

      <Table
         scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header2-table my-custom-table"
         // permet aussi de maintenir la couleur de la ligne
         rowClassName={(record) =>
          selectedRowKeys.includes(record.numligne) ? "selected-row" : ""
        }
        bordered
        showSorterTooltip={false}
        rowSelection={rowSelection}
        columns={columns}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        rowKey="numligne"
        dataSource={tableData.filter((data) => {
          if (selectEcriture === "Non") return  data.lettrage === "Non";
          if (selectEcriture === "Oui") return data.lettrage==="Oui";
          return true; 
        })} 
        title={() => (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Space>
              <strong>Total Débit: {formatNumber(totalDebit)}</strong> -
              <strong>Total Crédit: {formatNumber(totalCredit)}</strong> - (
              <strong style={{ color: "#4DBD74" }}>
                Soldes : {formatNumber(totalSolde)}
              </strong>
              )
            </Space>
            <Space>
              <strong>Solde de la sélection:</strong>
              <b style={{ color: "#4DBD74" }}>
                {soldeSelection.toLocaleString()}
              </b>
            </Space>
          </div>
        )}
      />
    </div>
  );
};

export default FournComptDiv;
